import OperationStatusResponse from '@/models/misc/OperationStatusResponse';
import EdiLinkLookup from "../models/edi/EdiLinkLookup";
import ServiceBase from "../services/ServiceBase";

class EdiService extends ServiceBase {
  getAllEdiLinks(): Promise<EdiLinkLookup[]> {
    return this.get<EdiLinkLookup[]>("/api/edi/tracking-links");
  }

  deleteEdiLinkBatch(request: any): Promise<OperationStatusResponse> {
    return this.put<OperationStatusResponse>("/api/edi/tracking-links", request, null);
  }

  saveEdiLink(request: any): Promise<OperationStatusResponse> {
    return this.post<OperationStatusResponse>("/api/edi/tracking-links", request, null);
  }
}

export default new EdiService();